import Conversation from "../../conversation/model/Conversation";

export default class ConversationFeedbackEvent {
    /**
     * @constructor
     * @param {string} type 
     * @param {Conversation} conversation 
     */
    constructor(type, conversation) {
        this._type = type;
        this._conversation = conversation;
    }

    get type() {
        return this._type;
    }

    get conversation() {
        return this._conversation;
    }
}

ConversationFeedbackEvent.FINISH = "ConversationFeedbackEvent.FINISH";